import { uiText } from '../i18n/uiText';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { authApi, getApiErrorMessage } from '../api';
import { useAuth } from '../store/AuthContext';

export default function ChangePasswordPage() {
  const navigate = useNavigate();
  const { user, refresh, setUser } = useAuth();
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [saving, setSaving] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');
    if (newPassword !== confirmPassword) {
      setError(uiText("Новый пароль и подтверждение не совпадают"));
      return;
    }
    setSaving(true);
    try {
      const response = await authApi.changePassword({
        current_password: currentPassword,
        new_password: newPassword,
      });
      const returnedUser = response?.data?.user;
      const normalizedUser = returnedUser ? { ...returnedUser, must_change_password: false, has_password: true } : null;
      if (normalizedUser && typeof setUser === 'function') {
        setUser(normalizedUser);
      }
      if (typeof refresh === 'function') {
        const refreshedUser = await refresh();
        if (refreshedUser && refreshedUser.must_change_password && typeof setUser === 'function') {
          setUser({ ...refreshedUser, must_change_password: false, has_password: true });
        }
      }
      setSuccess(uiText("Пароль изменён. Открываю приложение…"));
      setTimeout(() => navigate('/', { replace: true }), 0);
    } catch (e2) {
      setError(getApiErrorMessage(e2) || uiText("Не удалось изменить пароль"));
    } finally {
      setSaving(false);
    }
  };

  const isForced = !!user?.must_change_password;
  const needsCurrentPassword = user?.has_password !== false;

  return (
    <div className="page-content" style={{ maxWidth: 520, margin: '40px auto' }}>
      <div className="card">
        <div className="card-header">
          <h1 className="card-title" style={{ margin: 0 }}>{uiText("Смена пароля")}</h1>
        </div>
        <div className="card-body">
          {isForced && (
            <div className="alert" style={{ background: '#fff7ed', border: '1px solid #fed7aa', color: '#92400e', marginBottom: 14 }}>
              <b>{uiText("Требуется установить пароль.")}</b>{uiText(" Это первый вход в учётную запись, которую создал администратор. Пожалуйста, придумайте свой пароль — после этого вы получите доступ к системе.")}</div>
          )}
          {error && <div className="alert alert-error" style={{ marginBottom: 14 }}>{error}</div>}
          {success && <div className="alert alert-success" style={{ marginBottom: 14 }}>{success}</div>}
          <form onSubmit={submit}>
            {needsCurrentPassword ? (
              <div className="form-group">
                <label className="form-label required">{uiText("Текущий пароль")}</label>
                <input type="password" className="form-control" value={currentPassword} onChange={e => setCurrentPassword(e.target.value)} required autoFocus />
              </div>
            ) : (
              <div className="alert" style={{ background: '#f8fafc', border: '1px solid #e2e8f0', color: '#475569', marginBottom: 14 }}>{uiText("Текущего пароля ещё нет. Просто задайте новый пароль для дальнейших входов.")}</div>
            )}
            <div className="form-group">
              <label className="form-label required">{uiText("Новый пароль")}</label>
              <input type="password" className="form-control" value={newPassword} onChange={e => setNewPassword(e.target.value)} required minLength={10} autoFocus={!needsCurrentPassword} />
              <div style={{ fontSize: 12, color: '#666', marginTop: 4 }}>{uiText("Не короче 10 символов, минимум 1 буква, 1 цифра и 1 спецсимвол.")}</div>
            </div>
            <div className="form-group">
              <label className="form-label required">{uiText("Подтверждение пароля")}</label>
              <input type="password" className="form-control" value={confirmPassword} onChange={e => setConfirmPassword(e.target.value)} required minLength={10} />
            </div>
            <button type="submit" className="btn btn-primary" disabled={saving} style={{ width: '100%', justifyContent: 'center' }}>
              {saving ? uiText("Сохранение...") : uiText("Сменить пароль")}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
